module.exports = __webpack_public_path__ + "img/exitImg.a93145ce.svg";